import CloseIcon from '@mui/icons-material/Close';
import { Button,Dialog,DialogActions,DialogContent,DialogTitle,IconButton,TextField } from '@mui/material';
import { useContext,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../../context/UserContext';
import { trackEventMatomo } from '../../../helpers/matomo';

export default function EditModal({
  open,
  setOpen,
  componentName,
  edit,
  nameOf,
  isDisabled,
}
  : {
    open: boolean,
    setOpen: Function,
    componentName: string,
    edit: Function,
    nameOf: string,
    isDisabled: boolean,
  }) {

  const { t } = useTranslation('translation');
  const [name, setName] = useState(componentName);
  const { hierarchyLabel } = useContext(UserContext);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      scroll={'paper'}
      fullWidth
      maxWidth='sm'
    >
      <DialogTitle>{
        `${t('edit')} ${nameOf === 'conjunto'
          ? hierarchyLabel.conjunto ?? 'Conjunto'
          : hierarchyLabel.unidade ?? 'Unidade'}`}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => setOpen(false)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers={true}>
        <TextField
          onClick={() => trackEventMatomo('Modal edição conjunto/unidade', 'click', 'textfield', 'edita valor')}
          fullWidth
          label={t('name')}
          value={name ?? ''}
          onChange={(e) => setName(e.target.value)}
        />

      </DialogContent>
      <DialogActions>
        <Button disabled={isDisabled || !name} onClick={() => edit(name)}>
          {t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
